/* d1-link-cards — Link-Karten neben und über dem Text (2026-09-15)
 *
 * Liquid (sections/d1-link-cards.liquid) liefert die Karten als flachen Pool in <aside class="d1-lc">.
 * Dieses Skript sucht zu jeder Karte den passenden Link im Text und setzt die Karte daneben.
 *
 * Vier Darstellungen (data-mode):
 *   margin  Randnotiz  — Karte im freien Seitenrand auf Höhe ihres Absatzes, klebt in ihrem Band
 *   inset   Im Text    — der Textblock läuft schmaler, die Karten sitzen in der frei geräumten Spalte
 *   rail    Leiste     — alle Karten als ein klebender Stapel
 *   hover   Nur Hover  — Karte erscheint direkt am überfahrenen Link, mit Hintergrund
 *
 * Hover-Modus greift auch dort, wo Liquid den Text nicht lesen kann (Startseite: Absätze stehen in
 * Section-Einstellungen). Die Links werden dann aus dem gerenderten Text eingesammelt und die Karte
 * beim ersten Überfahren per Section-Rendering nachgeladen (sections/d1-link-card.liquid).
 *
 * Der Text selbst wird nie umgeschrieben. Die Karten-Ebene hängt am <body> — sonst würden die
 * .rte-Stile des Textes (blaue Link-Unterstreichung aus custom.css) auf die Karten durchschlagen.
 */
(function () {
  'use strict';

  var AUTO_TARGETS = [
    '.article__content',
    '.product-details__block',
    '.product-description',
    '#description .rte',
    '.page__content',
    '.section__block.rte',
    '.rte'
  ];
  var HIDE_DELAY = 220;
  var FETCH_SECTION = 'd1-link-card';

  function num(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function canHover() {
    return !window.matchMedia || window.matchMedia('(hover: hover)').matches;
  }

  function D1LinkCards(root) {
    this.root = root;
    this.items = Array.prototype.slice.call(root.querySelectorAll(':scope > .d1-lc-item'));
    var d = root.dataset;
    this.cfg = {
      mode: d.mode || 'margin',
      side: d.side || 'alternate',
      cardWidth: num(d.cardWidth, 280),
      offset: num(d.offset, 120),
      gap: num(d.gap, 32),
      minViewport: num(d.minViewport, 1240),
      mobile: d.mobile || 'inline',
      target: d.target || '',
      autoTarget: d.autoTarget || '',
      stripHeading: d.stripHeading || '',
      hoverExtra: d.hoverExtra === '1',
      style: d.style || 'full',
      types: d.types || 'pca',
      exclude: d.exclude || '',
      skipSelf: d.skipSelf === '1',
      labels: {
        product: d.labelProduct || '',
        collection: d.labelCollection || '',
        article: d.labelArticle || '',
        page: d.labelPage || ''
      }
    };
    this.layer = null;
    this.extra = null;
    this.pop = null;
    this.bindings = [];
    this.cache = {};
    this.pool = {};
    this.busy = false;
    this.signature = '';
    this.mode = null;

    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].dataset.path) this.pool[this.items[i].dataset.path] = this.items[i];
    }
    this.target = this.findTarget();

    if (!this.items.length && this.cfg.mode !== 'hover') return;
    if (!this.target) {
      if (window.Shopify && window.Shopify.designMode && this.items.length) {
        root.setAttribute('data-fallback', '1');
      }
      return;
    }
    this.init();
  }

  /* Ziel: 1. Selektor aus dem Editor, 2. Vorschlag aus Liquid (je Vorlage), 3. allgemeine Liste.
     Es gewinnt der sichtbare Kandidat, der die meisten der verlinkten Ziele wirklich enthält —
     auf der Produktseite gibt es mehrere Textblöcke, und der A+-Text ist nicht der erste davon. */
  D1LinkCards.prototype.findTarget = function () {
    var paths = [];
    for (var n = 0; n < this.items.length; n++) {
      if (this.items[n].dataset.path) paths.push(this.items[n].dataset.path);
    }
    // Gibt Liquid einen Zielselektor mit (Beitrag, Produkt, Collection), gilt nur dieser.
    // Sonst haengen sich die Karten an irgendeinen Textblock — auf den L1-Collectionseiten
    // zum Beispiel an den Promotext einer featured-collection, wenn der Beschreibungsblock
    // gar nicht ausgegeben wird (Metafeld custom.beschreibung).
    var selectors = this.cfg.autoTarget
      ? [this.cfg.target].concat(this.cfg.autoTarget.split('||'))
      : [this.cfg.target].concat(AUTO_TARGETS);
    var fallback = null;
    for (var i = 0; i < selectors.length; i++) {
      if (!selectors[i]) continue;
      var list;
      try { list = document.querySelectorAll(selectors[i]); } catch (e) { continue; }
      var cands = [];
      for (var k = 0; k < list.length; k++) {
        var el = list[k];
        if (el.offsetParent === null || el.offsetHeight < 80) continue;
        var len = el.textContent.trim().length;
        if (len < 200) continue;
        var hits = 0;
        for (var p = 0; p < paths.length; p++) {
          if (this.anchorsIn(el, paths[p]).length) hits++;
        }
        cands.push({ el: el, hits: hits, len: len });
      }
      // Verschachtelte Treffer: der innere gewinnt, solange er nichts verliert. Sonst landet
      // die Ebene auf dem aeusseren Abschnitts-Container statt auf dem Textblock darin.
      var inner = cands.filter(function (c) {
        for (var o = 0; o < cands.length; o++) {
          if (cands[o].el !== c.el && c.el.contains(cands[o].el) && cands[o].hits >= c.hits) return false;
        }
        return true;
      });
      var best = null, bestHits = -1, bestLen = -1;
      for (var m = 0; m < inner.length; m++) {
        if (inner[m].hits > bestHits || (inner[m].hits === bestHits && inner[m].len > bestLen)) {
          best = inner[m].el; bestHits = inner[m].hits; bestLen = inner[m].len;
        }
      }
      if (best && bestHits > 0) return best;
      if (best && !fallback) fallback = best;
    }
    return fallback;
  };

  /* Für den Hover-Modus: alle sichtbaren Textblöcke mit brauchbaren Links, nicht nur einer. */
  D1LinkCards.prototype.hoverTargets = function () {
    var selectors = this.cfg.autoTarget
      ? [this.cfg.target].concat(this.cfg.autoTarget.split('||'))
      : [this.cfg.target].concat(AUTO_TARGETS);
    var out = [];
    for (var i = 0; i < selectors.length; i++) {
      if (!selectors[i]) continue;
      var list;
      try { list = document.querySelectorAll(selectors[i]); } catch (e) { continue; }
      for (var k = 0; k < list.length; k++) {
        var el = list[k];
        if (el.offsetParent === null) continue;
        if (out.indexOf(el) !== -1) continue;
        // Verschachtelte Treffer vermeiden: der äußere Block reicht.
        var nested = false;
        for (var o = 0; o < out.length; o++) {
          if (out[o].contains(el) || el.contains(out[o])) { nested = true; break; }
        }
        if (nested) continue;
        if (this.usableLinks(el)) out.push(el);
      }
      if (out.length) return out;
    }
    return out;
  };

  D1LinkCards.prototype.usableLinks = function (el) {
    var links = el.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].closest('.d1-lc-item')) continue;
      if (this.pathInfo(links[i])) return true;
    }
    return false;
  };

  /* Link einordnen: Typ, Handle, normalisierter Pfad — oder null, wenn er nicht infrage kommt. */
  D1LinkCards.prototype.pathInfo = function (a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return null;
    var u;
    try { u = new URL(href, window.location.origin); } catch (e) { return null; }
    if (u.origin !== window.location.origin) return null;
    var low = u.pathname.replace(/\/+$/, '').toLowerCase();
    var type = null, handle = '', path = '', i;
    if ((i = low.indexOf('/products/')) !== -1) {
      handle = low.slice(i + 10).split('/')[0];
      type = 'p'; path = '/products/' + handle;
    } else if ((i = low.indexOf('/blogs/')) !== -1) {
      var rest = low.slice(i + 7).split('/');
      if (rest.length < 2 || !rest[1]) return null;
      handle = rest[1]; type = 'a'; path = '/blogs/' + rest[0] + '/' + rest[1];
    } else if ((i = low.indexOf('/pages/')) !== -1) {
      handle = low.slice(i + 7).split('/')[0];
      type = 'g'; path = '/pages/' + handle;
    } else if ((i = low.indexOf('/collections/')) !== -1) {
      handle = low.slice(i + 13).split('/')[0];
      if (handle === 'all') return null;
      type = 'c'; path = '/collections/' + handle;
    }
    if (!type || !handle) return null;
    if (this.cfg.types.indexOf(type) === -1) return null;
    if (this.cfg.exclude.indexOf('|' + handle + '|') !== -1) return null;
    if (this.cfg.skipSelf) {
      var here = window.location.pathname.replace(/\/+$/, '').toLowerCase();
      if (here.slice(-path.length) === path) return null;
    }
    return { type: type, path: path, handle: handle };
  };

  D1LinkCards.prototype.init = function () {
    var self = this;
    this.onResize = function () {
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () { self.schedule(true); }, 150);
    };
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', function () { self.schedule(true); });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) self.schedule(true);
    });
    // Lädt die Collection-Liste nach, wächst der Inhalt ÜBER dem Textblock: die Ebene steht dann
    // auf der alten Höhe und läge über dem Listing. Deshalb beim Scrollen die Lage nachziehen.
    this.onScroll = function () {
      if (self.popVisible) self.hideNow();
      // Bewusst per Zeitstempel gedrosselt, nicht per requestAnimationFrame: ein rAF-Flag bleibt
      // haengen, wenn der Tab beim Setzen im Hintergrund war — danach liefe der Abgleich nie mehr.
      var now = Date.now();
      if (now - (self.lastSync || 0) < 100) return;
      self.lastSync = now;
      self.syncLayer();
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(function () {
        if (self.busy || self.mode !== 'desktop') return;
        self.schedule(false);
      });
      this.ro.observe(this.target);
      var filterSpalte = document.querySelector('.main-products-grid__filters');
      if (filterSpalte) this.ro.observe(filterSpalte);
    }

    // Der Filter klappt mit Animation auf und zu. Der ResizeObserver feuert dabei mitten in der
    // Bewegung — deshalb nach dem Klick zweimal nachfassen, damit der Endzustand zaehlt.
    var filterBtn = document.querySelector('.products-toolbar__filter-btn');
    if (filterBtn) {
      filterBtn.addEventListener('click', function () {
        setTimeout(function () { self.schedule(true); }, 350);
        setTimeout(function () { self.schedule(true); }, 900);
      });
    }
    this.schedule(true);
  };

  /* Collection-Beschreibung: Der Textblock stand linksbuendig im Produktraster. Links war dann nie
     Rand frei (Karten raeumten eine Spalte im Text), rechts blieb Rand uebrig — das Ganze wirkte
     nach links verschoben. Jetzt mittig und hoechstens so breit, dass links und rechts je eine
     Kartenspalte innerhalb des Rasters Platz hat. Unter 600 px Text bleibt es beim alten Verhalten. */
  D1LinkCards.prototype.balance = function (on) {
    var box = this.target.parentElement;
    if (!box || !box.classList.contains('listing-text') || !box.closest('#description')) return;
    box.style.removeProperty('width');
    box.style.removeProperty('margin-left');
    box.style.removeProperty('margin-right');
    if (!on) return;
    var row = box.parentElement.getBoundingClientRect();
    var vpW = document.documentElement.clientWidth;
    var need = this.cfg.cardWidth + this.cfg.gap + 16;
    var mitte = row.left + row.width / 2;
    var max = parseFloat(box.style.maxWidth) || row.width;
    // Karten buendig mit der Aussenkante des Rasters (wie Logo und Breadcrumb), nie naeher am Fensterrand.
    var spalte = this.cfg.cardWidth + this.cfg.gap;
    var w = Math.floor(Math.min(max, row.width - 2 * spalte, 2 * (mitte - need), 2 * (vpW - mitte - need)));
    if (w < 600) return;
    box.style.width = w + 'px';
    box.style.marginLeft = 'auto';
    box.style.marginRight = 'auto';
  };

  /* Filterspalte des Produktrasters sichtbar? Nur dann blockiert sie die linke Seite. */
  D1LinkCards.prototype.filterOffen = function () {
    var raster = this.target.closest ? this.target.closest('.main-products-grid') : null;
    if (!raster) return false;
    var f = raster.querySelector('.main-products-grid__filters');
    return !!(f && f.offsetParent !== null && f.getBoundingClientRect().width > 0);
  };

  /* Alles, was ein neues Layout erzwingt. Breite des Textblocks und Filterzustand gehoeren dazu —
     sonst bleiben beim Aufklappen des Filters die linken Karten stehen. */
  D1LinkCards.prototype.sig = function () {
    var t = this.target;
    return window.innerWidth + '|' + Math.round(t.offsetWidth) + '|' + Math.round(t.offsetHeight)
      + '|' + (this.filterOffen() ? 1 : 0);
  };

  D1LinkCards.prototype.schedule = function (force) {
    var self = this;
    if (this.rafId) cancelAnimationFrame(this.rafId);
    clearTimeout(this.schedTimer);
    var run = function () {
      var sig = self.sig();
      if (!force && sig === self.signature) return;
      self.signature = sig;
      self.layout();
    };
    // In einem Hintergrund-Tab feuert requestAnimationFrame nicht — dort per Timer rechnen.
    if (document.hidden) this.schedTimer = setTimeout(run, 0);
    else this.rafId = requestAnimationFrame(run);
  };

  /* Ebene auf die aktuelle Lage des Textblocks ziehen (ohne Neuaufbau der Bänder). */
  D1LinkCards.prototype.syncLayer = function () {
    if (!this.layer || this.mode !== 'desktop') return;
    var r = this.target.getBoundingClientRect();
    var top = r.top + window.pageYOffset;
    var left = r.left + window.pageXOffset;
    if (Math.abs(top - this.layerTop) < 1 && Math.abs(left - this.layerLeft) < 1) return;
    this.layerTop = top;
    this.layerLeft = left;
    this.layer.style.top = top + 'px';
    this.layer.style.left = left + 'px';
  };

  /* ---------------------------------------------------------------- Aufräumen */
  D1LinkCards.prototype.teardown = function () {
    for (var b = 0; b < this.bindings.length; b++) {
      this.bindings[b].el.removeEventListener(this.bindings[b].type, this.bindings[b].fn);
    }
    this.bindings = [];
    for (var i = 0; i < this.items.length; i++) {
      var it = this.items[i];
      it.classList.remove('d1-lc-item--inline');
      it.removeAttribute('style');
      this.root.appendChild(it);
    }
    if (this.mobileRows) {
      for (var r = 0; r < this.mobileRows.length; r++) {
        if (this.mobileRows[r].parentNode) this.mobileRows[r].parentNode.removeChild(this.mobileRows[r]);
      }
      this.mobileRows = [];
    }
    if (this.layer) { this.layer.parentNode.removeChild(this.layer); this.layer = null; }
    if (this.extra) { this.extra.parentNode.removeChild(this.extra); this.extra = null; }
    if (this.pop) { this.pop.parentNode.removeChild(this.pop); this.pop = null; this.popVisible = false; }
    this.balance(false);
    this.target.classList.remove('d1-lc-inset', 'd1-lc-inset--left');
    this.target.style.removeProperty('--d1-lc-reserve');
    this.target.style.removeProperty('--d1-lc-reserve-r');
    this.target.style.removeProperty('--d1-lc-reserve-l');
    var marked = document.querySelectorAll('.d1-lc-anchor');
    for (var m = 0; m < marked.length; m++) marked[m].classList.remove('d1-lc-anchor');
  };

  D1LinkCards.prototype.bind = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts);
    this.bindings.push({ el: el, type: type, fn: fn });
  };

  /* --------------------------------------------------- Links im Text finden */
  D1LinkCards.prototype.anchors = function (path) {
    return this.anchorsIn(this.target, path);
  };

  D1LinkCards.prototype.anchorsIn = function (scope, path) {
    var out = [];
    if (!path || !scope) return out;
    var wanted = path.replace(/\/+$/, '').toLowerCase();
    var links = scope.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].closest('.d1-lc-item')) continue;
      var href = links[i].getAttribute('href');
      if (!href) continue;
      var p;
      try { p = new URL(href, window.location.origin).pathname; } catch (e) { continue; }
      p = p.replace(/\/+$/, '').toLowerCase();
      if (p === wanted || p.slice(-wanted.length) === wanted) out.push(links[i]);
    }
    return out;
  };

  // Direktes Kind des Textblocks, in dem der Link steht (Absatz, Liste, Tabelle …)
  D1LinkCards.prototype.blockOf = function (a) {
    var el = a;
    while (el && el !== this.target) {
      if (el.parentElement === this.target) return el;
      el = el.parentElement;
    }
    return null;
  };

  /* Die Karten-Ebene hängt am <body>. Die Klasse shopify-section bleibt dran, weil custom.css
     einige Kartenregeln damit einleitet (Label-Abstand, Grundpreis-Größe). */
  D1LinkCards.prototype.makeLayer = function () {
    var t = this.target;
    var r = t.getBoundingClientRect();
    var layer = document.createElement('div');
    layer.className = 'd1-lc-layer shopify-section';
    layer.style.top = (r.top + window.pageYOffset) + 'px';
    layer.style.left = (r.left + window.pageXOffset) + 'px';
    layer.style.width = r.width + 'px';
    layer.style.height = t.offsetHeight + 'px';
    document.body.appendChild(layer);
    this.layer = layer;
    this.layerTop = r.top + window.pageYOffset;
    this.layerLeft = r.left + window.pageXOffset;
    this.layerWidth = r.width;
    return layer;
  };

  /* ------------------------------------------------------------------- Layout */
  D1LinkCards.prototype.layout = function () {
    this.busy = true;
    this.teardown();

    var cfg = this.cfg;
    var t = this.target;
    // Collection-Beschreibung erst mittig setzen, dann messen: so reicht der Rand beidseitig.
    this.balance(window.innerWidth >= cfg.minViewport && cfg.side === 'alternate' &&
      (cfg.mode === 'auto' || cfg.mode === 'margin') && !this.filterOffen());
    var tr = t.getBoundingClientRect();
    var vpW = document.documentElement.clientWidth;
    var need = cfg.cardWidth + cfg.gap + 16;
    var spaceL = tr.left;
    var spaceR = vpW - tr.right;

    var sides = [];
    if (cfg.side === 'right') {
      if (spaceR >= need) sides = ['right'];
    } else if (cfg.side === 'left') {
      if (spaceL >= need) sides = ['left'];
    } else {
      if (spaceR >= need) sides.push('right');
      if (spaceL >= need) sides.push('left');
    }

    var wide = window.innerWidth >= cfg.minViewport;

    // Die Filterspalte steht LINKS vom Collectiontext. Der Platzcheck misst bis zum Fensterrand
    // und wuerde sie uebersehen — solange der Filter aufgeklappt ist, faellt links komplett weg.
    var filterDa = this.filterOffen();

    // Plan je Seite: freier Rand schlaegt Spalte im Text. Inset nur, solange der Text lesbar bleibt.
    var reserve = cfg.cardWidth + cfg.gap;
    var plan = { right: null, left: null };
    if (cfg.mode !== 'rail') {
      if (cfg.side !== 'left') plan.right = spaceR >= need ? 'margin' : 'inset';
      if (cfg.side !== 'right' && !filterDa) plan.left = spaceL >= need ? 'margin' : 'inset';
      if (cfg.mode === 'margin') {
        if (plan.right === 'inset') plan.right = null;
        if (plan.left === 'inset') plan.left = null;
      } else if (cfg.mode === 'inset') {
        if (plan.right) plan.right = 'inset';
        if (plan.left) plan.left = 'inset';
      }
      // Faellt der Text unter die Lesegrenze, eine Spalte im Text aufgeben (links zuerst).
      var minText = 520;
      var zaehle = function () {
        return (plan.right === 'inset' ? 1 : 0) + (plan.left === 'inset' ? 1 : 0);
      };
      while (zaehle() > 0 && tr.width - zaehle() * reserve < minText) {
        if (plan.left === 'inset') plan.left = null;
        else plan.right = null;
      }
    }
    var hatPlan = !!(plan.right || plan.left);
    var placed = false;

    if (cfg.mode === 'flow') {
      this.mode = 'mobile';
      this.layoutMobile();
      this.finish(t);
      return;
    }

    if (cfg.mode === 'hover') {
      placed = (wide && canHover()) ? this.setupHover() : false;
      if (placed) this.mode = 'hover';
    } else if (wide && (hatPlan || (cfg.mode === 'rail' && sides.length))) {
      this.mode = 'desktop';
      if (cfg.mode === 'rail' && sides.length) placed = this.layoutRail(sides[0]);
      else placed = this.layoutSides(plan);
    }

    if (!placed) {
      this.teardown();
      this.mode = 'mobile';
      this.layoutMobile();
    }

    // Die Huelle <aside class="d1-lc"> bleibt immer unsichtbar: sie ist nur der Vorrat. Die Karten
    // haengen entweder in der Ebene am body, im Textfluss oder als Klon im Hover-Popover.
    this.finish(t);
  };

  /* Abschluss jedes Layouts. Hover kann zusaetzlich zu jeder Darstellung laufen — auf der
     Produktseite stehen die Karten unter dem Text UND erscheinen beim Ueberfahren am Link. */
  D1LinkCards.prototype.finish = function (t) {
    var cfg = this.cfg;
    if (cfg.hoverExtra && cfg.mode !== 'hover' && window.innerWidth >= cfg.minViewport && canHover()) {
      this.setupHover();
    }
    this.signature = this.sig();
    var self = this;
    setTimeout(function () { self.busy = false; }, 60);
  };

  /* Bänder aufbauen: ein Band je Karte, je Seite gestapelt, Karte klebt im Band. */
  D1LinkCards.prototype.buildBands = function (sides, targetHeight, inside) {
    var cfg = this.cfg;
    var layer = this.layer;
    var tTop = this.layerTop;
    var nodes = [];
    var unanchored = [];

    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];
      var list = this.anchors(item.dataset.path);
      var block = list.length ? this.blockOf(list[0]) : null;
      var rawTop = null;
      if (block) rawTop = block.getBoundingClientRect().top + window.pageYOffset - tTop;

      var side = sides.length === 1 ? sides[0] : sides[i % sides.length];
      var band = document.createElement('div');
      // Schon einmal eingeblendet? Dann die Klassen VOR dem Einfuegen setzen, sonst laeuft bei
      // jedem neuen Layout (Bild nachgeladen, Fenster geaendert) die Einblendung noch einmal.
      band.className = item.dataset.seen === '1' ? 'd1-lc-band is-in d1-lc-band--static' : 'd1-lc-band';
      band.style.width = cfg.cardWidth + 'px';
      band.style.setProperty('--d1-lc-w', cfg.cardWidth + 'px');
      var art = inside && inside.plan ? inside.plan[side] : 'margin';
      if (art === 'inset') {
        if (side === 'right') band.style.right = inside.padR + 'px';
        else band.style.left = inside.padL + 'px';
      } else {
        if (side === 'right') band.style.left = 'calc(100% + ' + cfg.gap + 'px)';
        else band.style.right = 'calc(100% + ' + cfg.gap + 'px)';
      }
      item.style.setProperty('--d1-lc-top', cfg.offset + 'px');
      band.appendChild(item);
      layer.appendChild(band);

      var node = { band: band, item: item, side: side, rawTop: rawTop, h: 0 };
      nodes.push(node);
      if (rawTop === null) unanchored.push(node);
    }

    // Karten ohne Link im Text (manuelle Blöcke) gleichmäßig über den Text verteilen.
    for (var u = 0; u < unanchored.length; u++) {
      unanchored[u].rawTop = targetHeight * ((u + 0.5) / (unanchored.length + 1));
    }

    var maxSticky = window.innerHeight - cfg.offset - 24;
    for (var m = 0; m < nodes.length; m++) {
      nodes[m].h = nodes[m].item.offsetHeight;
      // Karte höher als das Fenster: nicht kleben lassen, sonst steht ihr Kopf über dem Bildschirm.
      nodes[m].item.classList.toggle('is-tall', nodes[m].h > maxSticky);
    }

    var lastBottom = { left: 0, right: 0 };
    var kept = [];
    for (var s = 0; s < nodes.length; s++) {
      var n = nodes[s];
      // Die Karte steht ÜBER ihrem Link: die Unterkante liegt auf Höhe des Absatzes, in dem
      // der Link steht. Vorher begann sie dort und lief nach unten weg.
      var wunsch = Math.max(0, n.rawTop + 24 - n.h);
      var start = Math.max(wunsch, lastBottom[n.side]);
      var maxStart = Math.max(0, targetHeight - n.h);
      if (start > maxStart) start = Math.max(lastBottom[n.side], maxStart);
      // Karte würde unten aus dem Textblock herauslaufen -> weglassen, sie läge sonst über
      // dem nächsten Abschnitt. Die nächste Karte kann auf der anderen Seite trotzdem passen.
      if (start + n.h > targetHeight + 80) {
        n.band.parentNode.removeChild(n.band);
        continue;
      }
      n.start = start;
      lastBottom[n.side] = start + n.h + cfg.gap;
      kept.push(n);
    }
    if (!kept.length) return false;

    // Bandhöhe = bis zur nächsten Karte derselben Seite, mindestens Kartenhöhe.
    var nextStart = {};
    for (var b = kept.length - 1; b >= 0; b--) {
      var nd = kept[b];
      var end = nextStart[nd.side] === undefined ? targetHeight : nextStart[nd.side] - cfg.gap;
      nd.height = Math.max(nd.h, end - nd.start);
      nextStart[nd.side] = nd.start;
    }
    for (var p = 0; p < kept.length; p++) {
      kept[p].band.style.top = Math.round(kept[p].start) + 'px';
      kept[p].band.style.height = Math.round(kept[p].height) + 'px';
    }

    this.reveal(kept);
    this.bindDim(kept);
    this.watchImages();
    return true;
  };

  /* Ueberfaehrt jemand einen Link im Text, tritt dessen Karte hervor und die anderen
     gehen in Grau. Nur sinnvoll, wenn ueberhaupt mehrere Karten zu sehen sind. */
  D1LinkCards.prototype.bindDim = function (nodes) {
    var self = this;
    if (nodes.length < 2) return;
    for (var i = 0; i < nodes.length; i++) {
      (function (item) {
        var on = function () { self.focusCard(item); };
        var off = function () { self.focusCard(null); };
        var list = self.anchors(item.dataset.path);
        for (var k = 0; k < list.length; k++) {
          list[k].classList.add('d1-lc-anchor');
          self.bind(list[k], 'mouseenter', on);
          self.bind(list[k], 'mouseleave', off);
          self.bind(list[k], 'focus', on);
          self.bind(list[k], 'blur', off);
        }
        self.bind(item, 'mouseenter', on);
        self.bind(item, 'mouseleave', off);
      })(nodes[i].item);
    }
  };

  D1LinkCards.prototype.focusCard = function (item) {
    if (!this.layer) return;
    var all = this.layer.querySelectorAll('.d1-lc-item');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.toggle('is-dim', !!item && all[i] !== item);
    }
  };

  /* Je Seite getrennt entscheiden: liegt daneben freier Rand, stehen die Karten DORT und der
     Text bleibt breit. Nur wo kein Rand frei ist, raeumt der Text selbst eine Spalte frei.
     Auf der Collection mit eingeklapptem Filter heisst das: rechts aussen, links im Text. */
  D1LinkCards.prototype.layoutSides = function (plan) {
    var t = this.target;
    var cfg = this.cfg;
    var cs = window.getComputedStyle(t);
    var padR = parseFloat(cs.paddingRight) || 0;
    var padL = parseFloat(cs.paddingLeft) || 0;
    var reserve = cfg.cardWidth + cfg.gap;
    var insetR = plan.right === 'inset';
    var insetL = plan.left === 'inset';

    if (insetR || insetL) {
      t.style.setProperty('--d1-lc-reserve-r', (insetR ? reserve + padR : padR) + 'px');
      t.style.setProperty('--d1-lc-reserve-l', (insetL ? reserve + padL : padL) + 'px');
      t.classList.add('d1-lc-inset');
    }
    // Der schmalere Text ist höher — erst nach dem Umbruch messen.
    var h = t.offsetHeight;
    this.makeLayer();

    var sides = [];
    if (plan.right) sides.push('right');
    if (plan.left) sides.push('left');
    return this.buildBands(sides, h, { plan: plan, padR: padR, padL: padL });
  };

  D1LinkCards.prototype.layoutRail = function (side) {
    var cfg = this.cfg;
    var layer = this.makeLayer();
    var band = document.createElement('div');
    band.className = 'd1-lc-band d1-lc-band--rail is-in';
    band.style.width = cfg.cardWidth + 'px';
    band.style.setProperty('--d1-lc-w', cfg.cardWidth + 'px');
    band.style.top = '0px';
    band.style.height = '100%';
    if (side === 'right') band.style.left = 'calc(100% + ' + cfg.gap + 'px)';
    else band.style.right = 'calc(100% + ' + cfg.gap + 'px)';

    var stack = document.createElement('div');
    stack.className = 'd1-lc-stack';
    stack.style.setProperty('--d1-lc-top', cfg.offset + 'px');
    for (var i = 0; i < this.items.length; i++) stack.appendChild(this.items[i]);
    band.appendChild(stack);
    layer.appendChild(band);
    var nodes = [];
    for (var n = 0; n < this.items.length; n++) nodes.push({ item: this.items[n] });
    this.bindDim(nodes);
    return true;
  };

  /* ------------------------------------------------------------------- Hover */
  D1LinkCards.prototype.setupHover = function () {
    var self = this;
    var targets = this.hoverTargets();
    if (!targets.length) return false;

    this.pop = document.createElement('div');
    this.pop.className = 'd1-lc-pop shopify-section';
    this.pop.style.width = this.cfg.cardWidth + 'px';
    document.body.appendChild(this.pop);
    this.popVisible = false;
    this.currentPath = null;

    for (var i = 0; i < targets.length; i++) {
      (function (target) {
        self.bind(target, 'mouseover', function (e) {
          var a = e.target.closest ? e.target.closest('a[href]') : null;
          if (!a || !target.contains(a) || a.closest('.d1-lc-item') || a.closest('.d1-lc-pop')) return;
          var info = self.pathInfo(a);
          if (!info) return;
          a.classList.add('d1-lc-anchor');
          self.showFor(a, info);
        });
        self.bind(target, 'mouseout', function (e) {
          var to = e.relatedTarget;
          if (to && self.pop && self.pop.contains(to)) return;
          self.hideSoon();
        });
        self.bind(target, 'focusin', function (e) {
          var a = e.target.closest ? e.target.closest('a[href]') : null;
          if (!a || !target.contains(a)) return;
          var info = self.pathInfo(a);
          if (info) self.showFor(a, info);
        });
        self.bind(target, 'focusout', function () { self.hideSoon(); });
      })(targets[i]);
    }

    this.bind(this.pop, 'mouseenter', function () { clearTimeout(self.hideTimer); });
    this.bind(this.pop, 'mouseleave', function () { self.hideSoon(); });
    return true;
  };

  D1LinkCards.prototype.showFor = function (anchor, info) {
    var self = this;
    clearTimeout(this.hideTimer);
    // mouseover feuert bei jeder Mausbewegung ueber dem Link. Steht die Karte schon am selben
    // Link, darf sie NICHT neu positioniert werden — sonst zittert sie unter dem Zeiger.
    if (this.currentPath === info.path && this.popVisible) {
      if (this.currentAnchor !== anchor) this.placePop(anchor);
      this.currentAnchor = anchor;
      return;
    }
    this.currentPath = info.path;
    this.currentAnchor = anchor;

    var pooled = this.pool[info.path];
    if (pooled) {
      this.fillPop(pooled.cloneNode(true));
      this.placePop(anchor);
      this.showPop();
      return;
    }
    this.pop.classList.add('is-loading');
    this.fetchCard(info.path).then(function (item) {
      if (self.currentPath !== info.path || !self.pop) return;
      self.pop.classList.remove('is-loading');
      if (!item) { self.hideNow(); return; }
      self.fillPop(item.cloneNode(true));
      self.placePop(anchor);
      self.showPop();
    });
  };

  /* Karte per Section-Rendering nachladen und merken. */
  D1LinkCards.prototype.fetchCard = function (path) {
    var self = this;
    if (this.cache[path]) return this.cache[path];
    var url = path + (path.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + FETCH_SECTION;
    var pr = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var item = tmp.querySelector('.d1-lc-item');
        if (!item) return null;
        self.decorate(item);
        return item;
      })
      .catch(function () { return null; });
    this.cache[path] = pr;
    return pr;
  };

  D1LinkCards.prototype.decorate = function (item) {
    if (this.cfg.style) item.classList.add('d1-lc-item--' + this.cfg.style);
    var label = this.cfg.labels[item.dataset.type];
    if (label && !item.querySelector('.d1-lc-eyebrow')) {
      var s = document.createElement('span');
      s.className = 'd1-lc-eyebrow';
      s.textContent = label;
      item.insertBefore(s, item.firstChild);
    }
  };

  D1LinkCards.prototype.fillPop = function (node) {
    this.pop.innerHTML = '';
    this.pop.appendChild(node);
    // Nachgeladene Karten bringen die Trusted-Shops-Sterne als leere Huelle mit —
    // d1-ratings.js fuellt sie erst, wenn es sie gesehen hat.
    if (window.D1Ratings && window.D1Ratings.scan) window.D1Ratings.scan(node);
  };

  D1LinkCards.prototype.showPop = function () {
    this.pop.classList.add('is-visible');
    this.popVisible = true;
  };

  D1LinkCards.prototype.hideSoon = function () {
    var self = this;
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(function () { self.hideNow(); }, HIDE_DELAY);
  };

  D1LinkCards.prototype.hideNow = function () {
    clearTimeout(this.hideTimer);
    if (!this.pop) return;
    this.pop.classList.remove('is-visible', 'is-loading');
    this.popVisible = false;
    this.currentPath = null;
    this.currentAnchor = null;
  };

  /* Karte direkt am Link platzieren (position: fixed), notfalls darüber statt darunter. */
  D1LinkCards.prototype.placePop = function (anchor) {
    var pad = 12;
    var pop = this.pop;
    var r = anchor.getBoundingClientRect();
    var w = this.cfg.cardWidth;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;

    pop.style.maxHeight = Math.max(240, vh - 2 * pad) + 'px';
    var h = pop.offsetHeight;

    var left = Math.min(r.left, vw - w - pad);
    left = Math.max(pad, left);

    var top = r.bottom + 10;
    if (top + h > vh - pad) {
      if (r.top - 10 - h >= pad) top = r.top - 10 - h;
      else top = Math.max(pad, vh - pad - h);
    }
    pop.style.left = Math.round(left) + 'px';
    pop.style.top = Math.round(top) + 'px';
  };

  /* Mobil */
  D1LinkCards.prototype.layoutMobile = function () {
    if (!this.items.length) return;
    var m = this.cfg.mobile;
    if (m === 'hidden') return;
    if (m === 'strip') {
      var wrap = document.createElement('div');
      wrap.className = 'd1-lc-strip-wrap';
      if (this.cfg.stripHeading) {
        var h = document.createElement('h2');
        h.className = 'd1-lc-strip-heading h6';
        h.textContent = this.cfg.stripHeading;
        wrap.appendChild(h);
      }
      var reihe = this.makeGroup(this.sortByType(this.items));
      wrap.appendChild(reihe);
      this.target.insertAdjacentElement('afterend', wrap);
      this.armCarousel(reihe);
      this.extra = wrap;
      return;
    }
    // inline: Karte direkt hinter den Absatz mit dem Link. Gehoeren mehrere Karten zum selben
    // Absatz, stuenden sie am Handy uebereinander — die laufen deshalb als Karussell.
    var groups = [];
    for (var k = 0; k < this.items.length; k++) {
      var item = this.items[k];
      var list = this.anchors(item.dataset.path);
      var block = list.length ? this.blockOf(list[0]) : null;
      if (block && block.parentElement !== this.target) block = null;
      var last = groups[groups.length - 1];
      // Nur gleiche Kartenart in eine Reihe: eine Kategorie-Karte neben Produktkarten
      // im selben Karussell sieht aus wie ein Fehler.
      if (last && last.block === block && last.type === item.dataset.type) last.items.push(item);
      else groups.push({ block: block, type: item.dataset.type, items: [item] });
    }
    this.mobileRows = [];
    for (var g = 0; g < groups.length; g++) {
      var grp = groups[g];
      // Auch die einzelne Karte laeuft ueber die Karussell-Auszeichnung: so sind alle Karten
      // im Textfluss gleich gross wie im Collection-Raster.
      var row = this.makeGroup(grp.items);
      if (grp.block) grp.block.insertAdjacentElement('afterend', row);
      else this.target.appendChild(row);
      this.armCarousel(row);
      this.mobileRows.push(row);
    }
  };

  /* Karten im Textfluss, nach Gruppengroesse:
       1 Karte  -> volle Breite des Textblocks, kein Karussell
       2 Karten -> zwei Spalten wie im Collection-Raster, nichts zu scrollen
       3+       -> Karussell, zwei Karten sichtbar, der Rest laeuft nach rechts

     Auszeichnung und CSS stammen vom Theme (.slider / .slider__grid / .slider__item wie in
     featured-collection und product-recommendations). Bewusst OHNE das Element <carousel-slider>:
     dessen Konstruktor liest die Slides beim Erzeugen, und dynamisch erzeugt haette er null.
     Die Pfeile des Elements sind ohnehin erst ab Desktop sichtbar — hier wird gewischt. */
  D1LinkCards.prototype.makeGroup = function (items) {
    var n = items.length;

    if (n === 1) {
      var solo = document.createElement('div');
      solo.className = 'd1-lc-group d1-lc-group--solo';
      solo.style.setProperty('--d1-lc-w', this.cfg.cardWidth + 'px');
      items[0].classList.add('d1-lc-item--inline');
      solo.appendChild(items[0]);
      return solo;
    }

    var wrap, grid, host;

    if (n === 2) {
      wrap = document.createElement('div');
      wrap.className = 'd1-lc-group d1-lc-group--pair';
      grid = document.createElement('ul');
      grid.setAttribute('role', 'list');
      grid.className = 'd1-lc-grid d1-lc-grid--pair small-cards-mobile gap-x-theme';
      host = wrap;
    } else {
      // Ab drei Karten das Karussell des Themes samt Pfeilen — aus der Vorlage geklont.
      var tpl = this.root.querySelector('template.d1-lc-tpl');
      if (tpl) {
        wrap = tpl.content.firstElementChild.cloneNode(true);
        grid = wrap.querySelector('.d1-lc-grid');
        var id = 'd1-lc-slider-' + (++sliderCount);
        var slider = wrap.querySelector('.slider');
        if (slider) slider.id = id;
        var btns = wrap.querySelectorAll('.slider-nav__btn');
        for (var b = 0; b < btns.length; b++) btns[b].setAttribute('aria-controls', id);
        host = null;
      } else {
        // Ohne Vorlage (aeltere Section im Editor): schlichtes Karussell ohne Pfeile.
        wrap = document.createElement('div');
        wrap.className = 'd1-lc-group carousel block d1-lc-carousel';
        var sl = document.createElement('div');
        sl.className = 'slider slider--contained';
        wrap.appendChild(sl);
        grid = document.createElement('ul');
        grid.setAttribute('role', 'list');
        grid.className = 'd1-lc-grid slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile sm:auto-cols-3 gap-x-theme';
        host = sl;
      }
    }

    for (var i = 0; i < items.length; i++) {
      var li = document.createElement('li');
      li.className = 'slider__item';
      li.appendChild(items[i]);
      grid.appendChild(li);
    }
    if (host) host.appendChild(grid);
    return wrap;
  };

  /* In der gesammelten Reihe unter dem Text stehen erst die Produkte, dann die Kategorien,
     danach Beitraege und Seiten. Innerhalb einer Art bleibt die Reihenfolge des Textes. */
  D1LinkCards.prototype.sortByType = function (items) {
    var rang = { product: 0, collection: 1, article: 2, page: 3 };
    return items.slice().sort(function (a, b) {
      var ra = rang[a.dataset.type], rb = rang[b.dataset.type];
      if (ra === undefined) ra = 9;
      if (rb === undefined) rb = 9;
      return ra - rb;
    });
  };

  /* Das Element <carousel-slider> liest seine Slides im Konstruktor — und der laeuft beim
     Klonen der Vorlage, wenn das Raster noch leer ist. Also nach dem Einhaengen die Slides
     nachreichen und die Lazy-Initialisierung des Themes selbst anstossen. Ohne das bleibt das
     Karussell auf "inactive" und die Pfeile tun nichts. */
  D1LinkCards.prototype.armCarousel = function (el) {
    if (!el) return;
    var car = el.tagName === 'CAROUSEL-SLIDER' ? el : el.querySelector('carousel-slider');
    if (!car || typeof car.init !== 'function' || car.slider) return;
    car.slides = car.querySelectorAll('.slider__item');
    if (car.slides.length < 2) return;
    if (window.initLazyScript) window.initLazyScript(car, car.init.bind(car));
    else car.init();
  };

  /* Einblenden, sobald das Band ins Bild kommt — aber nur beim ersten Mal. Ein erneutes
     Layout (Bild nachgeladen, Fenster geändert) darf die Karten nicht wieder einfaden. */
  D1LinkCards.prototype.reveal = function (nodes) {
    var fresh = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].item.dataset.seen === '1') nodes[i].band.classList.add('is-in');
      else fresh.push(nodes[i]);
    }
    if (!fresh.length) return;
    if (!window.IntersectionObserver) {
      for (var f = 0; f < fresh.length; f++) {
        fresh[f].band.classList.add('is-in');
        fresh[f].item.dataset.seen = '1';
      }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      for (var e = 0; e < entries.length; e++) {
        if (entries[e].isIntersecting) {
          entries[e].target.classList.add('is-in');
          var it = entries[e].target.querySelector('.d1-lc-item');
          if (it) it.dataset.seen = '1';
          io.unobserve(entries[e].target);
        }
      }
    }, { rootMargin: '0px 0px -10% 0px' });
    for (var n = 0; n < fresh.length; n++) io.observe(fresh[n].band);
  };

  /* Bilder in den Karten laden nach -> Höhen ändern sich -> einmal nachrechnen */
  D1LinkCards.prototype.watchImages = function () {
    var self = this;
    if (!this.layer) return;
    var imgs = this.layer.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete) continue;
      imgs[i].addEventListener('load', function () {
        clearTimeout(self.imgTimer);
        self.imgTimer = setTimeout(function () { self.schedule(true); }, 120);
      }, { once: true });
    }
  };

  /* ---------------------------------------------------------------- Bootstrap */
  var sliderCount = 0;
  var instances = [];
  // Debug-Zugriff für die Konsole: window.__d1lc[0] zeigt Ziel, Modus und Konfiguration.
  window.__d1lc = instances;

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('.d1-lc');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.bound) continue;
      roots[i].dataset.bound = '1';
      instances.push(new D1LinkCards(roots[i]));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('.d1-lc')) boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root && !document.body.contains(instances[i].root) && instances[i].target) {
        instances[i].teardown();
      }
    }
  });
})();
